module.exports = __webpack_public_path__ + "assets/c77d7f4c229a18f85ea83673d2646748.mp3";